document.addEventListener('DOMContentLoaded', () => {
  const collectionBanner = () => {
    let isOpen = false
    const descriptionEl = document.querySelector('#collection-description')
    if (!descriptionEl) return

    const originalCopy = descriptionEl?.innerHTML
    const hiddenCopy = descriptionEl?.textContent.substring(0, 160)
    const button = document.createElement('button')
    button.classList.add('underline', 'text-grey-500')

    const setHidden = () => {
      button.innerText = 'Read more'
      descriptionEl.innerHTML = '<span>' + hiddenCopy + '... </span>'
      descriptionEl.appendChild(button)
      descriptionEl.setAttribute('style', 'height: auto')
      isOpen = false
    }

    const setVisible = () => {
      descriptionEl.innerHTML = originalCopy
      button.innerText = 'Read less'
      descriptionEl.appendChild(button)
      isOpen = true
    }

    button.addEventListener('click', () => {
      if (isOpen) {
        setHidden()
        return
      }

      setVisible()
    })

    setHidden()
  }
  collectionBanner()
})
